import React from 'react'

export default function ServiceCard({service,cardFor}) {
 return (
  <div className="col-md-4 col-sm-10 pb-4 doctor" data-aos="fade-down"  data-aos-delay="200">

  <img  src={service.img} alt="" width={cardFor==="doctor" ? "25%" : "20%"}/>
  <div className="doctor_data">
   <span>{service.name}</span>
   <h5>{service.title}</h5>
   {/* <p>{service.description} <span>{cardFor==="doctor" ? "Details" : "Get Appointment"}</span></p>  */}
   <p>{service.description} </p> 
   
   <span style={{color:"red", cursor:"pointer"}}>{cardFor==="doctor" ? "Details" : "Get Appointment"}</span>
  </div>
   
  </div>
 )
}
